import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/firstDownCard.css';
// constants
import {
    ALL_FIRST_DOWN_MARKETS,
    FIELD_GOAL,
    FIFTH_PLAY,
    FIRST_PLAY,
    FOURTH_PLAY,
    SECOND_PLAY,
    THIRD_PLAY
} from '../constants/marketTypes';
import {ASSETS_URL} from '../../../../../constants/endpoints';
// helpers
import {areFirstDownMarketsExpanded, getMarketsByCode} from '../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// containers
import Accordion from '../containers/accordion';
// components
import FirstPlay from '../components/firstPlay';
import SecondPlay from '../components/secondPlay';
import ThirdPlay from '../components/thirdPlay';
import FourthPlay from '../components/fourthPlay';
import FifthOrMorePlay from '../components/fifthOrMorePlay';
import FieldGoal from '../components/fieldGoal';
import {HARD_SUSPENDED, NMB, PRE, RES, SOFT_SUSPENDED, VID} from '../../../../../constants/identifiers';
import {getAllWrappedBets} from '../../../helpers/betHelpers';

// actions
import {collapseAllMarkets, expandAllMarkets} from '../actions/marketsActions';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        firstDownMarketsExpanded: state.vpp.firstDownMarketsExpanded,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        channelEventBets: state.vpp.channelEventBets
    };
};

class FirstDownCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            firstDownMarketsExpanded: storeData.vpp.firstDownMarketsExpanded,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                firstDownMarketsExpanded: storeData.vpp.firstDownMarketsExpanded,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp
            });
        }
    }

    _generateMarketUI(marketCode, marketList, key) {
        let store = this.props.store;
        let marketUI;
        let markets = getMarketsByCode(marketCode, marketList);
        let content;
        switch (marketCode) {
            case FIRST_PLAY:
                content = (<FirstPlay callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                marketUI = (
                    <Accordion marketLabel={'FIRST_PLAY'} store={store} key={key} index={key} content={content}/>);
                break;
            case SECOND_PLAY:
                content = (<SecondPlay callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                marketUI = (
                    <Accordion marketLabel={'SECOND_PLAY'} store={store} key={key} index={key} content={content}/>);
                break;
            case THIRD_PLAY:
                content = (<ThirdPlay callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                marketUI = (
                    <Accordion marketLabel={'THIRD_PLAY'} store={store} key={key} index={key} content={content}/>);
                break;
            case FOURTH_PLAY:
                content = (<FourthPlay callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                marketUI = (
                    <Accordion marketLabel={'FOURTH_PLAY'} store={store} key={key} index={key} content={content}/>);
                break;
            case FIFTH_PLAY:
                content = (<FifthOrMorePlay callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                marketUI = (
                    <Accordion marketLabel={'FIFTH_PLAY'} store={store} key={key} index={key} content={content}/>);
                break;
            case FIELD_GOAL:
                content = (<FieldGoal callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                marketUI = (
                    <Accordion marketLabel={'FIELD_GOAL'} store={store} key={key} index={key} content={content}/>);
                break;
            default:
                break;
        }
        return marketUI;
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let marketsUI;
        if (selectedEvent.markets && selectedEvent.markets.length) {
            marketsUI = ALL_FIRST_DOWN_MARKETS.map((mkt, index) => this._generateMarketUI(mkt, selectedEvent.markets, index));
        }

        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let eventBets;
        if (selectedEvent) {
            eventBets = getAllWrappedBets(this.state, selectedEvent.channel).filter(
                (pBet) => pBet.Bets[0].EventId === selectedEvent.eventId.toString() && pBet.Bets[0].Channel === selectedEvent.channel
            );
        }

        let noMoreBetsOverlay;
        if (selectedEvent && this.props.overlay === undefined) {
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    let overlayText;
                    if (selectedGame.controllerState === PRE || selectedGame.controllerState === NMB) {
                        overlayText = 'NO_MORE_BETS';
                    } else if (selectedGame.controllerState === VID || selectedGame.controllerState === RES) {
                        overlayText = 'EVENT_LIVE'
                    }
                    if (overlayText) {
                        if (overlayText == "EVENT_LIVE") {
                            noMoreBetsOverlay = (
                                <div className={style.noMoreBetsOverlay}>
                                    <div className={style.noMoreBetsText} id={'noMoreBetsText'}>
                                        {getText('Current_Event_Live', this.props.store)}
                                        <br/>
                                        {getText('Select_From_Future', this.props.store)}<br
                                        class={style.display}/>{getText('Events_Above', this.props.store)}
                                    </div>
                                </div>
                            );
                        } else {
                            noMoreBetsOverlay = (
                                <div className={style.noMoreBetsOverlay}>
                                    <div className={style.noMoreBetsText} id={'noMoreBetsText'}>
                                        {getText(overlayText, this.props.store)}
                                    </div>
                                </div>
                            );
                        }
                    }
                    break;
                }
            }
        }

        let gameDisabledOverlay;
        if (selectedEvent && this.props.overlay === undefined) {
            if (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === HARD_SUSPENDED ||
                (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === SOFT_SUSPENDED && eventBets.length <= 0) ||
                (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === SOFT_SUSPENDED && eventBets.length > 0 && selectedGame.controllerState !== VID && selectedGame.controllerState !== RES)
            ) {
                gameDisabledOverlay = (<div className={style.noMoreBetsOverlay}>
                    <div className={style.noMoreBetsText} id={'gameDisabled'}>
                        {getText('GAME_DISABLED', this.props.store)}
                    </div>
                </div>);
            }
        }

        let overlay;
        if (this.props.overlay) {
            overlay = this.props.overlay;
        } else if (gameDisabledOverlay) {
            overlay = gameDisabledOverlay;
        } else {
            overlay = noMoreBetsOverlay;
        }

        let actionType = (selectedEvent.awayTeam === selectedEvent.defenseTeam)
            ? 'DEFENDS'
            : 'ATTACKS';

        return (<div className={style.mainContainer}>
            <div className={style.titleCollapseButtonContainer}>
                <div id='gameTitleBanner' className={style.gameTitleBanner}>
                    <img
                        src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/Preamble1_LogoName_Left_${this.state.events[this.state.selectedEventIndex].awayTeam}.png`}
                        className={style.teamNameIconImage}
                        alt={`${this.state.events[this.state.selectedEventIndex].awayTeam}`}/>
                    <img
                        src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/Preamble1_Helmets_Left_${this.state.events[this.state.selectedEventIndex].awayTeam}.png`}
                        className={style.teamHelmetIconImage}
                        alt={`${this.state.events[this.state.selectedEventIndex].awayTeam}`}/>
                    <div className={style.vsText}>{getText(actionType, this.props.store)}</div>
                    <img
                        src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/Preamble1_Helmets_Right_${this.state.events[this.state.selectedEventIndex].homeTeam}.png`}
                        className={style.teamHelmetIconImage}
                        alt={`${this.state.events[this.state.selectedEventIndex].homeTeam}`}/>
                    <img
                        src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/Preamble1_LogoName_Right_${this.state.events[this.state.selectedEventIndex].homeTeam}.png`}
                        className={style.teamNameIconImage}
                        alt={`${this.state.events[this.state.selectedEventIndex].homeTeam}`}/>
                    <div
                        className={style.meetingName}>{` - ${this.state.events[this.state.selectedEventIndex].meetingName}`}</div>
                </div>
                <div className={style.expandCollapseButton}
                     onClick={() => areFirstDownMarketsExpanded(this.state.firstDownMarketsExpanded)
                         ? store.dispatch(collapseAllMarkets())
                         : store.dispatch(expandAllMarkets())}>{
                    areFirstDownMarketsExpanded(this.state.firstDownMarketsExpanded)
                        ? getText('COLLAPSE_ALL', store)
                        : getText('EXPAND_ALL', store)
                }</div>
            </div>
            <div className={style.firstDownCard}>{overlay}{marketsUI}</div>
        </div>);
    }
}

export default connect(mapStateToProps)(FirstDownCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/containers/firstDownCard.js